// extracted by mini-css-extract-plugin
module.exports = {"buttonHold":"HoldButton_buttonHold__3ww3o","loading":"HoldButton_loading__1TNJu","success":"HoldButton_success__3c3ck"};